import { render, staticRenderFns } from "./SkillStub.vue?vue&type=template&id=55d662fd&scoped=true&"
import script from "./SkillStub.vue?vue&type=script&lang=ts&"
export * from "./SkillStub.vue?vue&type=script&lang=ts&"
import style0 from "./SkillStub.vue?vue&type=style&index=0&id=55d662fd&lang=less&scoped=true&"
import style1 from "./SkillStub.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d662fd",
  null
  
)

export default component.exports